import { ReactNode, useContext, useEffect } from "react";
import Nav from "../nav/Nav";
import { AppStateService } from "../../services/appStateService";
import { AppMainStateContext } from "../../contexts/AppMainStateContext.tsx";
import { NavMobileBottomBar } from "../nav/NavMobileBottomBar.tsx";
import NavMobileTopBar from "../nav/NavMobileTopBar.tsx";
import { CookieAgreeModal } from "../modals/CookieAgreeModal.tsx";
import Footer from "../footer/Footer.tsx";

export const MainLayout = ({ children, isFooterVisible = true, contentPadding = "px-4 pb-4 pt-16 md:pt-0" }: { children: ReactNode, isFooterVisible?: boolean, contentPadding?: string }) => {
    // services
    const _appStateService = new AppStateService();
    // contexts
    const {
        isMobile,
        appStates,
        setIsCookiesAgreed,
        isModalOpen,
        openModal,
        closeModal
    } = useContext(AppMainStateContext);

    const handleCookiesAgreedClick = (isAgreed: boolean) => {
        _appStateService.setIsCookiesAgreed(isAgreed);
        setIsCookiesAgreed(isAgreed);
        if (isAgreed)
            openModal();
    };

    useEffect(() => {
        if (appStates.isCookiesAgreed === "not set") {
            openModal();
        }
        else closeModal();

    }, [appStates]);

    return (
        <>
            {isMobile ?
                <>
                    <NavMobileTopBar />
                    <NavMobileBottomBar />
                    <main className="h-full flex flex-col">
                        <main className={`flex-auto ${contentPadding} ${!isFooterVisible ? "pb-0" : ""}`}>{children}</main>
                        {isFooterVisible === true ? <Footer /> : null}
                    </main>
                    {/* <main className={"min-h-screen max-h-screen overflow-y-scroll flex flex-col"}>
                        {children}
                    </main> */}
                </>
                :
                <>
                    <div className="h-full">
                        <Nav />
                        <div className="flex h-full flex-col pl-24" id="main-content">
                            {/* {children} */}
                            <main className={`flex-auto ${contentPadding} ${!isFooterVisible ? "pb-0" : ""}`}>{children}</main>
                            {isFooterVisible === true ? <Footer /> : null}
                            {/* <Footer /> */}
                        </div>
                    </div>
                    {/* <Nav />
                    <div className="relative flex h-full flex-col pl-24 px-4 bg-neutral-800">
                        <main className="flex-auto">{children}</main>
                        <Footer />
                    </div> */}
                    {/* <main id={"main-container"}
                        className={"relative pl-24 flex flex-col min-h-screen bg-neutral-800"}>
                        {children}
                    </main> */}
                    {/* <main id={"main-container"}
                        className={"relative pl-24 flex flex-col w-full min-h-screen bg-neutral-800"}>
                        {children}
                    </main> */}
                </>
            }
            <CookieAgreeModal
                isOpen={appStates.isCookiesAgreed === "not set" && isModalOpen}
                onClose={() => {
                    handleCookiesAgreedClick(false);
                }} />
        </>
    );
};
